
import React, { lazy } from "react";
const KetQuaFixture = lazy(() => import("@/components/client/KetQuaFixture"), {
  loading: () => <p>Loading...</p>, // Thêm loader nếu cần
});
const HeaderFixtureResult = lazy(() => import("@/components/client/HeaderFixtureResult"), {
  loading: () => <p>Loading...</p>, // Thêm loader nếu cần
});

const KetQuaPlugin = () => {  
  return (
    <div>
      <HeaderFixtureResult title={`Kết quả bóng đá`} />
      <KetQuaFixture page="ketqua" status={"end"} />
    </div>
  );
}

export default React.memo(KetQuaPlugin);
